module.exports = __webpack_public_path__ + "img/exchange-alt-solid.8ad4b6e8.svg";